var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareFeedbackProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6005 28.0733L16.9237 25.9885L17.4417 22.6475L17.6527 21.2855C17.8605 19.9457 16.7078 18.7496 15.2097 18.7496H9.55762C9.08456 18.7496 8.83477 18.3114 9.02042 17.9188C9.52 16.8658 9.80309 16.0044 10.0393 14.9559C10.167 14.3885 10.2577 13.9725 10.2577 13.6306C10.2577 11.8432 8.47026 11.5664 8.47026 11.5664C8.47026 11.5664 4.5538 16.6954 2.90889 18.0992C1.76541 19.0754 1 20.3572 1 21.7794V25.4317C1 28.5071 3.76126 31.0001 7.16766 31.0001H12.9282C14.7946 31.0001 16.3686 29.7455 16.6005 28.0733Z",
    stroke: "#192643",
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3995 3.92669L18.0763 6.01149L17.5583 9.35252L17.3473 10.7145C17.1395 12.0543 18.2922 13.2504 19.7903 13.2504H25.4424C25.9154 13.2504 26.1652 13.6886 25.9796 14.0812C25.48 15.1342 25.1969 15.9956 24.9607 17.0441C24.833 17.6115 24.7423 18.0275 24.7423 18.3694C24.7423 20.1568 26.5297 20.4336 26.5297 20.4336C26.5297 20.4336 30.4462 15.3046 32.0911 13.9008C33.2346 12.9246 34 11.6428 34 10.2206V6.56833C34 3.49291 31.2387 0.999943 27.8323 0.999943H22.0718C20.2054 0.999943 18.6314 2.2545 18.3995 3.92669Z",
    stroke: "#192643",
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFeedbackProfile);
export default __webpack_public_path__ + "static/media/shareFeedbackProfile.130651db43f9868a164a40d19eedd13f.svg";
export { ForwardRef as ReactComponent };